module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEhSURBVHgBrdRBisIwFAbg99K47xE8QucGM0cYGGaYnYq4UqRH8ARF3LlQXAm68QZ6A3uEHqF7Nc/3qq2hKJraH0oL+fORpBCECommq0BrjPjzk58YjBkNun8bGUNwzBXb0mVyTEBNBJSn1e/8LJxAGzsd6Svs/cbRfNn0yNsKyiv9fhm8hxVjjGrSe0RIlAvGnz6RGduYJGz/JyDbJwiertBeGQCl9nmVOntAitFlm9A4pfl55Wi5g69i+Tbtn2DIjBSqod1BF6wYt1DupHZHuWJZDp7PmF/GJOiKPetgnVgB1oVlYJ2YRDc0zrnoc/HjXUyiuBjwe1cHloGPBqpgD8GqmAQns7XMS0Fu3luCKphE842bZJfj5TrPs2MsdMUkZ3AfI5U8jN8dAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sidebar-icons/notes-disable.png
// module id = vAG/
// module chunks = 37